<template>
  <div style="height: 100%">
    <v-layout v-if="projectCase === 'loggedOut' || projectCase === 'adminSubscribe' || projectCase === 'viewerRequestSubscription'" row style="height: 100%; position: relative;" id="projectPanel">
      <v-flex xs4 style="height: 100%; padding: 40px 30px 90px 30px; position: relative; z-index: 9">
        <div class="secondary--text" style="text-transform: capitalize; font-size: 24px; font-weight: 700; margin-bottom: 5px" v-if="options.project">{{options.project.name}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 700; margin-bottom: 10px">{{getOrganizationName()}}</div>
        <div class="secondary--text" style="font-size: 10px; font-weight: 500; margin-bottom: 30px">{{getDateCreated()}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 500; margin-bottom: 30px">{{options.project.description}}</div>
        <v-layout row v-if="displayTabs === 'overview'">
          <v-btn flat round v-if="projectCase === 'loggedOut' || projectCase === 'adminSubscribe'" :ripple="false" class="noHoverBtn secondary primary--text" @click="displayTabs = 'plans'" style="height: 45px">Subscribe</v-btn>
          <v-btn flat round :ripple="false" class="noHoverBtn secondary primary--text" @click="displayTabs = 'plans'" v-if="projectCase === 'viewerRequestSubscription'" style="height: 45px">Request Project</v-btn>
          <div style="display: flex; align-items: center; color: white; font-size: 12px; font-weight: 700">{{options.project.projectUserOrganizations.length}} Subscribers</div>
        </v-layout>
        <div v-if="displayTabs === 'plans'" style="position: absolute; top: 40px; bottom: 90px; right: 0;border-right: 1px solid #0C4991;"></div>
        <div class="projectCategories">
          <div class="secondary--text" style="font-size: 14px; font-weight: bold; margin-bottom: 10px">Categories:</div>
          <div class="projectCategoriesContainer"><v-chip v-for="(item, index) in options.project.config.categories" :key="index" style="text-transform: capitalize; font-size: 14px" small class="accent secondary--text">{{item}}</v-chip></div>
        </div>
      </v-flex>
      <v-flex xs8 :class="displayTabs === 'overview' ? 'panelImage' : 'primary panelNoImage'" :style="displayTabs === 'overview' ? { 'background-image': 'url(' + options.project.config.unsplashImageUrl + ')' } : ''">
        <div class="panelImageOverlay" v-if="displayTabs === 'overview'"></div>
        <div v-if="displayTabs === 'plans'" class="projectPlans">
          <div v-for="item in options.project.plans" v-if="item.tier !== 0 || isMasterUser" :key="item.id" class="secondary--text" style="padding-right: 15px">
            <div style="font-size: 18px; font-weight: 700">{{item.displayName}}</div>
            <v-layout row style="margin-top: 20px">
              <div style="font-size: 48px; font-weight: 300; line-height: 44px">${{ item.fixedFee}}</div>
              <div style="font-size: 18px; display: flex; align-items: flex-end; flex-wrap: no-wrap; padding-left: 3px">{{'/' + getPeriod(item.period)}}</div>
            </v-layout>
            <div style="font-size: 14px; margin-top: 20px">Includes:</div>
            <ul>
              <li style="font-size: 14px" class="bulletPoint">Unlimited users</li>
              <li>{{item.description}}</li>
            </ul>
            <v-btn class="noHoverBtn" flat outline round color="secondary" dark :ripple="false" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px" @click="choosePlan(item.id)" :loading="projectCase === 'viewerRequestSubscription' && choosePlanLoading && selectedPlanId && selectedPlanId === item.id">Choose Plan</v-btn>
          </div>
        </div>
      </v-flex>
      <div class="panelTabs">
        <div class="panelTab secondary--text" :class="getTabClass('overview')" @click="displayTabs = 'overview'">Overview</div>
        <div class="panelTab secondary--text" :class="getTabClass('plans')" @click="displayTabs = 'plans'">Plans</div>
      </div>
    </v-layout>
    <v-layout v-if="projectCase === 'subscribedAdmin' || projectCase === 'subscribedAdminDiy' || projectCase === 'adminPendingExternalApproval'" row style="height: 100%; position: relative;" id="projectPanel">
      <v-flex xs4 style="height: 100%; padding: 40px 30px 90px 30px; position: relative; z-index: 9">
        <div class="secondary--text" style="text-transform: capitalize; font-size: 24px; font-weight: 700; margin-bottom: 5px" v-if="options.project">{{options.project.name}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 700; margin-bottom: 10px">{{getOrganizationName()}}</div>
        <div class="secondary--text" style="font-size: 10px; font-weight: 500; margin-bottom: 30px">{{getDateCreated()}}</div>
        <div v-if="displayTabs !== 'users' && displayTabs !== 'stats'" class="secondary--text" style="font-size: 14px; font-weight: 500; margin-bottom: 30px">{{options.project.description}}</div>
        <v-layout row v-if="displayTabs === 'overview'">
          <v-btn flat v-if="projectCase === 'subscribedAdmin' || projectCase === 'subscribedAdminDiy'" round :ripple="false" class="noHoverBtn secondary primary--text" @click="goToProject()" style="text-transform: capitalize; font-size: 18px; height: 45px;">Go to project</v-btn>
          <v-btn flat v-if="projectCase === 'subscribedAdmin'" round :ripple="false" class="noHoverBtn secondary primary--text" @click="manageProject()" style="text-transform: capitalize; font-size: 18px; height: 45px;">Manage</v-btn>
          <v-btn flat v-if="projectCase === 'subscribedAdminDiy'" round :ripple="false" class="noHoverBtn secondary primary--text" @click="editProject()" style="text-transform: capitalize; font-size: 18px; height: 45px;">Edit</v-btn>
          <v-btn disabled flat round :ripple="false" class="noHoverBtn secondary primary--text" v-if="projectCase === 'adminPendingExternalApproval'" style="text-transform: capitalize; font-size: 18px; height: 45px;">Pending External Approval</v-btn>
          <div style="display: flex; align-items: center; color: white; font-size: 12px; font-weight: 700">{{options.project.projectUserOrganizations.length}} Subscribers</div>
        </v-layout>
        <div v-if="displayTabs !== 'overview' && displayTabs !== 'users' && displayTabs !== 'stats'" style="position: absolute; top: 40px; bottom: 90px; right: 0;border-right: 1px solid #0C4991;"></div>
        <div class="projectCategories">
          <div class="secondary--text" style="font-size: 14px; font-weight: bold; margin-bottom: 10px">Categories:</div>
          <div class="projectCategoriesContainer"><v-chip v-for="(item, index) in options.project.config.categories" :key="index" style="text-transform: capitalize; font-size: 14px" small class="accent secondary--text">{{item}}</v-chip></div>
        </div>
      </v-flex>
      <v-flex class="usersTab" v-if="displayTabs === 'users'" style="display: flex">
        <div style="position: relative; height: 100%; width: 80%">
          <v-layout row wrap style="height: 90%; padding: 20px 60px; display: flex; align-items: center; flex-wrap: wrap;">
            <v-flex v-for="item in displayedUsers" :key="item.id" style="max-width: 360px">
              <v-layout row wrap style="display: flex; align-items: center;">
                <img style="max-height: 70px" src="@/assets/user.png"/>
                <v-flex style="padding-left: 15px; padding-right: 10px">
                  <div style="color: white; font-size: 16px; font-weight: 700" v-if="item.firstName">{{item.firstName + ' ' + item.lastName}}</div>
                  <div style="color: white; font-size: 16px; font-weight: 700" v-else>{{item.email}}</div>
                  <div style="color: white; font-size: 14px">{{getUserRole(item)}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex xs12 py-3 style="display: flex; justify-content: center; height: 10%;">
            <v-pagination :total-visible="7" @input="getUsers" class="usersPagination" light v-model="pageNumber" :length="totalPages" ></v-pagination>
          </v-flex>
        </div>
        <div style="position: relative; height: 100%; width: 20%; display: flex; align-items: center; justify-content: center" class="secondary--text">
          <v-btn style="text-transform: capitalize; height:45px; min-width: 160px; font-size: 18px;" flat round :ripple="false" class="noHoverBtn secondary primary--text" @click="manageUsers">Manage Users</v-btn>
        </div>
      </v-flex>
      <v-flex class="usersTab" v-if="displayTabs === 'stats' && projectCase === 'subscribedAdminDiy'">
        <div style="position: relative; height: 100%; width: 100%">
          <v-layout row style="height: 90%; padding: 20px 0px; display: flex; align-items: center; justify-content: space-around">
            <div class="secondary--text text-xs-center">
              <div style="font-size: 36px; font-weight: 300">${{plan.fixedFee}}</div>
              <div style="font-size: 18px; font-weight: 700">{{planPeriod}} Payment</div>
            </div>
            <div class="secondary--text text-xs-center" v-if="nextBillingDate">
              <div style="font-size: 36px; font-weight: 300">{{formattedBillingDate}}</div>
              <div style="font-size: 18px; font-weight: 700">Next Billing Date</div>
            </div>
            <div class="statsSeparator"></div>
            <div class="secondary--text text-xs-center">
              <div style="font-size: 36px; font-weight: 300">{{numberOfSubs}}</div>
              <div style="font-size: 18px; font-weight: 700">Subscriptions</div>
            </div>
            <!-- <div class="secondary--text text-xs-center">
              <div style="font-size: 36px; font-weight: 300">$1020</div>
              <div style="font-size: 18px; font-weight: 700">Monthly Earnings</div>
            </div>
            <div class="secondary--text text-xs-center">
              <div style="font-size: 36px; font-weight: 300">$2040</div>
              <div style="font-size: 18px; font-weight: 700">Total Earnings</div>
            </div> -->
            <div class="secondary--text text-xs-center">
              <div style="font-size: 36px; font-weight: 300">{{plan.displayName}}</div>
              <div style="font-size: 18px; font-weight: 700">Tier</div>
            </div>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs8 :class="displayTabs === 'overview' ? 'panelImage' : 'primary panelNoImage'" :style="displayTabs === 'overview' ? { 'background-image': 'url(' + options.project.config.unsplashImageUrl + ')' } : ''">
        <div class="panelImageOverlay" v-if="displayTabs === 'overview'"></div>
      </v-flex>
      <div class="panelTabs">
        <div class="panelTab secondary--text" :class="getTabClass('overview')" @click="displayTabs = 'overview'">Overview</div>
        <div v-if="projectCase === 'subscribedAdminDiy'" class="panelTab secondary--text" :class="getTabClass('stats')" @click="displayTabs = 'stats'">Stats</div>
        <div class="panelTab secondary--text" :class="getTabClass('users')" @click="displayTabs = 'users'">Users</div>
      </div>
    </v-layout>
    <v-layout v-if="projectCase === 'subscribedViewer' || projectCase === 'viewerRequestSent' || projectCase === 'viewerRequestAccess' || projectCase === 'viewerPendingApproval'" row style="height: 100%; position: relative;" id="projectPanel">
      <v-flex xs4 style="height: 100%; padding: 40px 30px 90px 30px; position: relative; z-index: 9">
        <div class="secondary--text" style="text-transform: capitalize; font-size: 24px; font-weight: 700; margin-bottom: 5px" v-if="options.project">{{options.project.name}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 700; margin-bottom: 10px">{{getOrganizationName()}}</div>
        <div class="secondary--text" style="font-size: 10px; font-weight: 500; margin-bottom: 30px">{{getDateCreated()}}</div>
        <div v-if="displayTabs !== 'users' && displayTabs !== 'stats'" class="secondary--text" style="font-size: 14px; font-weight: 500; margin-bottom: 30px">{{options.project.description}}</div>
        <v-layout row v-if="displayTabs === 'overview'">
          <v-btn flat round v-if="projectCase === 'subscribedViewer'" :ripple="false" class="noHoverBtn secondary primary--text" @click="goToProject()" style="text-transform: capitalize; font-size: 18px; height: 45px;">Go to project</v-btn>
          <v-btn disabled flat round :ripple="false" class="noHoverBtn secondary primary--text" v-if="projectCase === 'viewerRequestSent'" style="text-transform: capitalize; font-size: 18px; height: 45px;">Request Sent</v-btn>
          <v-btn disabled flat round :ripple="false" class="noHoverBtn secondary primary--text" v-if="projectCase === 'viewerPendingApproval' && projectStatus.toLowerCase().includes('external')" style="text-transform: capitalize; font-size: 18px; height: 45px;">Pending External Approval</v-btn>
          <v-btn disabled flat round :ripple="false" class="noHoverBtn secondary primary--text" v-if="projectCase === 'viewerPendingApproval' && projectStatus.toLowerCase().includes('organization')" style="text-transform: capitalize; font-size: 18px; height: 45px;">Pending Organization Approval</v-btn>
          <v-btn flat round :ripple="false" class="noHoverBtn secondary primary--text" @click="requestAccess" v-if="projectCase === 'viewerRequestAccess'" :loading="requestAccessLoading === 'loading'" style="height: 45px">Request Access</v-btn>
          <div style="display: flex; align-items: center; color: white; font-size: 12px; font-weight: 700">{{options.project.projectUserOrganizations.length}} Subscribers</div>
        </v-layout>
        <div class="projectCategories">
          <div class="secondary--text" style="font-size: 14px; font-weight: bold; margin-bottom: 10px">Categories:</div>
          <div class="projectCategoriesContainer"><v-chip v-for="(item, index) in options.project.config.categories" :key="index" style="text-transform: capitalize; font-size: 14px" small class="accent secondary--text">{{item}}</v-chip></div>
        </div>
      </v-flex>
      <v-flex xs8 class="panelImage" :style="displayTabs === 'overview' ? { 'background-image': 'url(' + options.project.config.unsplashImageUrl + ')' } : ''">
        <div class="panelImageOverlay" v-if="displayTabs === 'overview'"></div>
      </v-flex>
      <div class="panelTabs">
        <div class="panelTab secondary--text" :class="getTabClass('overview')" @click="displayTabs = 'overview'">Overview</div>
      </div>
    </v-layout>
    <v-layout v-if="projectCase === 'adminPendingOrganizationApproval'" row style="height: 100%; position: relative;" id="projectPanel">
      <v-flex xs4 style="height: 100%; padding: 40px 30px 90px 30px; position: relative; z-index: 9">
        <div class="secondary--text" style="text-transform: capitalize; font-size: 24px; font-weight: 700; margin-bottom: 5px" v-if="options.project">{{options.project.name}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 700; margin-bottom: 10px">{{getOrganizationName()}}</div>
        <div class="secondary--text" style="font-size: 10px; font-weight: 500; margin-bottom: 30px">{{getDateCreated()}}</div>
        <div v-if="displayTabs !== 'users' && displayTabs !== 'stats'" class="secondary--text" style="font-size: 14px; font-weight: 500; margin-bottom: 30px">{{options.project.description}}</div>
        <v-layout row v-if="displayTabs === 'overview'">
          <v-btn flat round :ripple="false" class="noHoverBtn secondary primary--text" @click="editProject" :loading="requestAccessLoading === 'loading'" style="height: 45px">Edit Project</v-btn>
        </v-layout>
        <div class="projectCategories">
          <div class="secondary--text" style="font-size: 14px; font-weight: bold; margin-bottom: 10px">Categories:</div>
          <div class="projectCategoriesContainer"><v-chip v-for="(item, index) in options.project.config.categories" :key="index" style="text-transform: capitalize; font-size: 14px" small class="accent secondary--text">{{item}}</v-chip></div>
        </div>
      </v-flex>
      <v-flex xs8 class="panelImage" :style="displayTabs === 'overview' ? { 'background-image': 'url(' + options.project.config.unsplashImageUrl + ')' } : ''">
        <div class="panelImageOverlay" v-if="displayTabs === 'overview'"></div>
      </v-flex>
      <div class="panelTabs">
        <div class="panelTab secondary--text" :class="getTabClass('overview')" @click="displayTabs = 'overview'">Overview</div>
      </div>
    </v-layout>
    <v-layout v-if="projectCase === 'adminRequestedProject'" row style="height: 100%; position: relative;" id="projectPanel">
      <v-flex xs4 style="height: 100%; padding: 40px 30px 90px 30px; position: relative; z-index: 9">
        <div class="secondary--text" style="text-transform: capitalize; font-size: 24px; font-weight: 700; margin-bottom: 5px" v-if="options.project">{{options.project.name}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 700; margin-bottom: 10px">{{getOrganizationName()}}</div>
        <div class="secondary--text" style="font-size: 10px; font-weight: 500; margin-bottom: 30px">{{getDateCreated()}}</div>
        <div class="secondary--text" style="font-size: 14px; font-weight: 500; margin-bottom: 30px">{{options.project.description}}</div>
        <v-layout row v-if="displayTabs === 'overview'">
          <v-btn flat round :ripple="false" class="noHoverBtn secondary primary--text" @click="displayTabs = 'plans'" style="height: 45px" v-if="$route.path.includes('requests')">Subscribe</v-btn>
          <v-btn flat round @click="$router.push('/organization/requests')" :ripple="false" class="noHoverBtn secondary primary--text" style="height: 45px" v-else>Project requested</v-btn>
          <div style="display: flex; align-items: center; color: white; font-size: 12px; font-weight: 700">{{options.project.projectUserOrganizations.length}} Subscribers</div>
        </v-layout>
        <div v-if="displayTabs === 'plans'" style="position: absolute; top: 40px; bottom: 90px; right: 0;border-right: 1px solid #0C4991;"></div>
        <div class="projectCategories">
          <div class="secondary--text" style="font-size: 14px; font-weight: bold; margin-bottom: 10px">Categories:</div>
          <div class="projectCategoriesContainer"><v-chip v-for="(item, index) in options.project.config.categories" :key="index" style="text-transform: capitalize; font-size: 14px" small class="accent secondary--text">{{item}}</v-chip></div>
        </div>
      </v-flex>
      <v-flex xs8 :class="displayTabs === 'overview' ? 'panelImage' : 'primary panelNoImage'" :style="displayTabs === 'overview' ? { 'background-image': 'url(' + options.project.config.unsplashImageUrl + ')' } : ''">
        <div class="panelImageOverlay" v-if="displayTabs === 'overview'"></div>
        <div v-if="displayTabs === 'plans'" class="projectPlans">
          <div v-for="item in options.project.plans" v-if="item.tier !== 0 || isMasterUser" :key="item.id" class="secondary--text" style="padding-right: 15px">
            <div style="font-size: 18px; font-weight: 700">{{item.displayName}}</div>
            <v-layout row style="margin-top: 20px">
              <div style="font-size: 48px; font-weight: 300; line-height: 44px">${{ item.fixedFee}}</div>
              <div style="font-size: 18px; display: flex; align-items: flex-end; flex-wrap: no-wrap; padding-left: 3px">{{'/' + getPeriod(item.period)}}</div>
            </v-layout>
            <div style="font-size: 14px; margin-top: 20px">Includes:</div>
            <ul>
              <li style="font-size: 14px" class="bulletPoint">Unlimited users</li>
              <li>{{item.description}}</li>
            </ul>
            <v-btn class="noHoverBtn" flat outline round color="secondary" dark :ripple="false" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px; display: flex" @click="choosePlan(item.id)">Choose Plan</v-btn>
            <div :style="planSuggested(item.id) ? 'color: white' : 'color: transparent'" style="font-size: 14px; text-align: center; padding-top: 5px">Suggested by user*</div>
          </div>
        </div>
      </v-flex>
      <div class="panelTabs">
        <div class="panelTab secondary--text" :class="getTabClass('overview')" @click="displayTabs = 'overview'">Overview</div>
        <div class="panelTab secondary--text" :class="getTabClass('plans')" @click="displayTabs = 'plans'">Plans</div>
      </div>
    </v-layout>
  </div>
</template>

<style>
  .statsSeparator{
    height: 100%;
    width: 0;
    border-left: 1px solid #0C4991;
    margin: 0 1px;
  }
  .usersPagination button{
    font-size: 0 !important;
    box-shadow: none;
    border-radius: 100%;
    width: 10px;
    height: 10px;
    opacity: 0.3;
  }
  .usersPagination .v-pagination__navigation{
    background-color: transparent !important;
  }
  .usersPagination .v-pagination__navigation i{
    font-size: 0
  }
  .usersPagination .v-pagination__navigation{
    background-image: url(/static/prevBtn.png) !important;
    transform: rotateY(-180deg) translateY(-50%);
    width: 20px !important;
    height: 60px !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -14px
  }
  .usersPagination .v-pagination__navigation:not(.v-pagination__navigation--disabled){
    opacity: 1
  }
  .usersPagination li:nth-child(1) .v-pagination__navigation{
    transform: translateY(-50%);
    left: 0;
    right: auto;
  }
  .usersPagination .v-pagination__item.v-pagination__item--active{
    background-color: white !important;
    opacity: 1 !important;
  }
  .usersTab{
    position: absolute;
    left: 30px;
    right: 30px;
    top: 140px;
    bottom: 100px;
    z-index: 9;
  }
  .noHoverBtn:hover:before{
    background-color: transparent;
  }
  .projectPlans{
    position: absolute;
    z-index: 4;
    top: 40px;
    bottom: 90px;
    left: 30px;
    right: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .panelImage{
    height: 100%;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .panelNoImage{
    height: 100%;
    position: relative;
  }
  .panelTab{
    margin: 0 10px;
    border-bottom: 7px solid transparent;
    cursor: pointer;
  }
  .activePanelTab{
    border-bottom-color: white;
  }
  .panelTabs{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 24px;
    font-weight: 700;
    z-index: 2
  }
  .projectCategories{
    position: absolute;
    bottom: 30px;
    left: 30px;
    right: 30px;
  }
  .panelImageOverlay{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: -moz-linear-gradient(left, rgba(1,30,65,1) 0%, rgba(32,124,202,0.44) 100%);
    background: -webkit-linear-gradient(left, rgba(1,30,65,1) 0%,rgba(32,124,202,0.44) 100%);
    background: linear-gradient(to right, rgba(1,30,65,1) 0%,rgba(32,124,202,0.44) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#011e41', endColorstr='#70207cca',GradientType=1 );
    z-index: 1
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      displayTabs: 'overview',
      users: [],
      totalPages: 1,
      pageNumber: 1,
      displayedUsers: [],
      usersCount: 3,
      nextBillingDate: null,
      requestAccessLoading: 'none',
      selectedPlanId: -1,
      choosePlanLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getRoleById: 'getRoleById',
      getPlanById: 'getPlanById',
      getRoleByName: 'getRoleByName'
    }),
    formattedBillingDate () {
      if (this.nextBillingDate) {
        var date = new Date(Number(this.nextBillingDate) * 1000)
        var month = this.months[date.getMonth() + 1]
        var day = date.getDate()
        var year = date.getFullYear()
        var nextDate = month + ' ' + day + ', ' + year
        return nextDate
      }
      return ''
    },
    projectCase () {
      if (this.isLoggedIn) {
        if (this.isOrganizationProject) {
          if (this.isDiy) {
            if (this.projectStatus.toLowerCase().includes('active')) {
              if (this.isAdmin) {
                return 'subscribedAdminDiy'
              } else {
                if (this.isOrganizationUserProject) {
                  if (this.organizationUserProjectStatus.toLowerCase().includes('active')) {
                    return 'subscribedViewer'
                  } else {
                    return 'viewerRequestSent'
                  }
                } else {
                  return 'viewerRequestAccess'
                }
              }
            } else {
              if (this.isAdmin) {
                if (this.organizationProjectStatus.toLowerCase().includes('external')) {
                  return 'adminPendingExternalApproval'
                } else {
                  return 'adminPendingOrganizationApproval'
                }
              } else {
                if (this.isCreatedByUser) {
                  return 'viewerPendingApproval'
                }
              }
            }
          } else {
            if (this.isAdmin) {
              if (this.organizationProjectStatus.toLowerCase().includes('active')) {
                return 'subscribedAdmin'
              } else {
                return 'adminRequestedProject'
              }
            } else {
              if (this.isOrganizationUserProject) {
                if (this.organizationUserProjectStatus.toLowerCase().includes('active')) {
                  return 'subscribedViewer'
                } else {
                  return 'viewerRequestSent'
                }
              } else {
                return 'viewerRequestAccess'
              }
            }
          }
        } else {
          if (this.isAdmin) {
            return 'adminSubscribe'
          } else {
            return 'viewerRequestSubscription'
          }
        }
      } else {
        return 'loggedOut'
      }
    },
    isAdmin () {
      return this.getUserOrganization && this.currentUser && this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId !== this.getRoleByName('VIEWER_ROLE').id
    },
    isOrganizationProject () {
      return this.getUserOrganization && this.getUserOrganization.organizationProjects && this.getUserOrganization.organizationProjects.length > 0 && this.getUserOrganization.organizationProjects.filter(item => { return item.projectId === this.options.project.id }).length > 0
    },
    isMasterUser () {
      return this.currentUser && Number(this.getRoleByName('MASTER_ROLE').id) === Number(this.currentUser.defaultRoleId)
    },
    isDiy () {
      return this.getUserOrganization && this.options.project.projectOrganizations.find(item => { return item.organizationId === this.getUserOrganization.id }) && this.options.project.projectOrganizations.find(item => { return item.organizationId === this.getUserOrganization.id }).type === 'DIY'
    },
    projectStatus () {
      return this.options.project.status
    },
    organizationProjectStatus () {
      return this.getUserOrganization.organizationProjects.find(item => { return item.projectId === this.options.project.id }).status
    },
    isOrganizationUserProject () {
      return this.options.project && this.getUserOrganization && this.getUserOrganization.organizationUserProjects.filter(item => { return item.projectId === this.options.project.id && item.userId === this.currentUser.id }).length !== 0
    },
    organizationUserProjectStatus () {
      return this.getUserOrganization.organizationUserProjects.find(item => { return item.projectId === this.options.project.id && item.userId === this.currentUser.id }).status
    },
    isCreatedByUser () {
      return this.options.project && this.currentUser && this.options.project.createdByUserId === this.currentUser.id
    },
    notTier0 () {
      return this.plan.tier !== 0
    },
    plan () {
      return this.getPlanById(this.options.project.projectOrganizations.find(item => { return item.organizationId === this.getUserOrganization.id }).planId)
    },
    planPeriod () {
      var period = this.plan.period
      if (period === 'MONTHLY') {
        return 'Monthly'
      } else if (period === 'QUARTERLY') {
        return 'Quarterly'
      } else if (period === 'YEARLY') {
        return 'Yearly'
      } else {
        return ''
      }
    },
    numberOfSubs () {
      return this.options.project.projectOrganizations.length
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    planSuggested (planId) {
      return this.getUserOrganization.organizationProjects.find(item => { return item.projectId === this.options.project.id }).planId === planId
    },
    editProject () {
      this.$router.push({path: '/diy', query: {project: this.options.project.id, display: 'edit'}})
    },
    manageProject () {
      this.$emit('manage-project')
    },
    requestAccess () {
      this.requestAccessLoading = 'loading'
      axios.all([this.$store.dispatch('requestAccessToProject', {requestingOrganizationId: this.getUserOrganization.id, requestingUserId: this.currentUser.id, requestedProjectId: this.options.project.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.getOrganizationData()
        } else {
          this.requestAccessLoading = 'none'
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.requestAccessLoading = 'none'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
          this.requestAccessLoading = 'complete'
          this.choosePlanLoading = false
          // this.selectedPlanId = null
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    choosePlan (planId) {
      if (this.isLoggedIn) {
        if (this.isAdmin) {
          this.$emit('subscribe', {projectId: this.options.project.id, planId: planId})
          this.displayTabs = 'overview'
        } else {
          this.choosePlanLoading = true
          this.selectedPlanId = planId
          this.sendProjectSuggestion()
        }
      } else {
        var query = {path: this.$route.path, input: this.$route.query.input, category: this.$route.query.category, display: 'search', order: this.$route.query.order, planId: planId, projectId: this.options.project.id}
        if (this.options.trending) {
          query.trending = true
        } else if (this.options.popular) {
          query.popular = true
        } else if (this.options.recommended) {
          query.recommended = true
        }
        this.$router.push({path: 'login', query: query})
      }
    },
    sendProjectSuggestion () {
      var organizationAdmins = this.getUserOrganization.organizationUsers.filter(item => { return item.roleId === this.getRoleByName('ADMIN_ROLE').id })
      var subscriptionObject = {organizationId: this.getUserOrganization.id, projectId: this.options.project.id, planId: this.selectedPlanId, type: 'SUBSCRIPTION', status: 'Pending Organization Approval'}
      var currentUserObject = {
        organizationId: this.getUserOrganization.id,
        projectId: this.options.project.id,
        userId: this.currentUser.id,
        roleId: this.getRoleByName('VIEWER_ROLE').id,
        status: 'Pending Organization Approval'
      }
      axios.all([this.$store.dispatch('addOrganizationProject', subscriptionObject), this.$store.dispatch('addOrganizationUserProject', currentUserObject)]).then(axios.spread((orgProjectResponse, orgUserResponse) => {
        if (orgProjectResponse.data.status === 'SUCCESS' && orgUserResponse.data.status === 'SUCCESS') {
          for (var u = 0; u < organizationAdmins.length; u++) {
            var organizationUserProject = {
              organizationId: orgProjectResponse.data.payload.organizationId,
              projectId: orgProjectResponse.data.payload.projectId,
              userId: organizationAdmins[u].userId,
              roleId: this.getRoleByName('ADMIN_ROLE').id,
              status: 'Pending Organization Approval'
            }
            axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
              if (orgUserProjectResponse.data.status === 'SUCCESS') {
                if (u >= organizationAdmins.length - 1) {
                  axios.all([this.$store.dispatch('getUserByUuid', {uuid: this.currentUser.uuid})]).then(axios.spread((userResponse) => {
                    if (userResponse.data.status === 'SUCCESS') {
                      this.$store.commit('auth/setUser', userResponse.data.payload)
                      this.getOrganizationData()
                    } else {
                      this.notify({message: 'Something went wrong.', show: true})
                    }
                  })).catch((err) => {
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                }
              } else {
                this.notify({message: 'Something went wrong.', show: true})
              }
            })).catch((err) => {
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.$emit('close-subscribe-dialog')
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        }
      })).catch((err) => {
        this.$emit('close-subscribe-dialog')
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getPeriod (tierPeriod) {
      if (tierPeriod === 'MONTHLY') {
        return 'mo'
      } else if (tierPeriod === 'QUARTERLY') {
        return 'qt'
      } else if (tierPeriod === 'YEARLY') {
        return 'yr'
      } else {
        return ''
      }
    },
    getTabClass (tab) {
      if (tab === this.displayTabs) {
        return 'activePanelTab'
      }
      return ''
    },
    manageUsers () {
      this.$emit('manage-users')
    },
    getOrganizationName () {
      var organization = this.options.project.organizations.find(item => { return item.id === this.options.project.createdByOrganizationId })
      if (organization) {
        return organization.name
      }
      return ''
    },
    getDateCreated () {
      var dateAdded = new Date(this.options.project.dateAdded.date.year, this.options.project.dateAdded.date.month - 1, this.options.project.dateAdded.date.day, this.options.project.dateAdded.time.hour, this.options.project.dateAdded.time.minute, this.options.project.dateAdded.time.second)
      var day = dateAdded.getDay()
      var month = dateAdded.getMonth()
      var date = dateAdded.getDate()
      var year = dateAdded.getFullYear()
      var hour = dateAdded.getHours()
      var minutes = dateAdded.getMinutes()
      if (hour >= 24) {
        day = day + 1
      }
      var amPm = 'AM'
      if (hour > 12) {
        hour = hour % 12
        amPm = 'PM'
      } else if (hour === 12) {
        amPm = 'PM'
      }
      return this.days[day] + ' ' + this.months[month] + ' ' + date + ', ' + year + ' - ' + ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm
    },
    getUsers () {
      var organizationUsers = this.getUserOrganization.users
      this.users = []
      var organizationUserProjects = this.getUserOrganization.organizationUserProjects.filter(item => { return item.projectId === this.options.project.id })
      for (var u = 0; u < organizationUserProjects.length; u++) {
        var user = organizationUsers.find(item => { return item.id === organizationUserProjects[u].userId })
        if (user) {
          this.users.push(user)
        }
      }
      this.displayedUsers = []
      for (var x = (this.pageNumber - 1) * this.usersCount; x < ((this.pageNumber - 1) * this.usersCount) + this.usersCount; x++) {
        if (this.users[x]) {
          this.displayedUsers.push(this.users[x])
        }
      }
      if (this.usersCount > 0) {
        this.totalPages = Math.ceil(this.users.length / this.usersCount)
      }
      if (this.isDiy) {
        this.getBillingInfo()
      }
    },
    getBillingInfo () {
      let stripeSubIds = []
      let upcomingInvoice = []
      for (let stripeId in this.getUserOrganization.stripeSubConfig) {
        if (stripeId !== 'billing_cycle_anchor') {
          stripeSubIds.push(this.getUserOrganization.stripeSubConfig[stripeId])
        }
      }
      axios.all([this.$store.dispatch('stripe/getUpcomingInvoiceByCustomerId', {organizationUuid: this.getUserOrganization.uuid, stripeSubIds: stripeSubIds})]).then(axios.spread((response) => {
        if (response !== undefined) {
          if (response.length > 0) {
            for (let i = 0; i < response.length; i++) {
              if (response[i].data.payload) {
                var plan = response[i].data.payload.lines.data.find(item => { return item.plan.id.split('_prod_')[1].split('_plan')[0] === this.options.project.uuid })
                if (plan) {
                  upcomingInvoice.push(response[i].data.payload.nextPaymentAttempt)
                }
              }
            }
            if (upcomingInvoice.length > 0) {
              this.nextBillingDate = upcomingInvoice[0]
            }
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loadingState = 'error'
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loadingState = 'error'
        console.log(err)
      })
    },
    getUserRole (user) {
      var organizationUser = this.getUserOrganization.organizationUsers.find(item => { return item.userId === user.id })
      var role = this.getRoleById(organizationUser.roleId)
      return role.displayName
    },
    goToProject () {
      var route = 'https://app.dataslicer.io/#/home?projectUuid=' + this.options.project.uuid
      window.open(route, '_blank')
    }
  },
  mounted () {
    // console.log(this.options.project)
    this.displayTabs = 'overview'
    if (this.$route.query && this.$route.query.planId && this.notSubscribed) {
      this.displayTabs = 'plans'
    }
    setTimeout(function () {
      if (document.getElementById('projectPanel')) {
        this.usersCount = Math.floor((document.getElementById('projectPanel').offsetWidth - 120) / 360) * 2
      }
    }, 2)
    if (this.isLoggedIn && !this.notSubscribed) {
      this.getUsers()
    }
  },
  watch: {
    'options.project': function (newval, oldval) {
      this.displayTabs = 'overview'
      if (this.$route.query && this.$route.query.planId && this.notSubscribed) {
        this.displayTabs = 'plans'
      }
      setTimeout(function () {
        if (document.getElementById('projectPanel')) {
          this.usersCount = Math.floor((document.getElementById('projectPanel').offsetWidth - 120) / 360) * 2
        }
      }, 2)
      // if (this.isLoggedIn && !this.notSubscribed) {
      //   this.getUsers()
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/ProjectPanel.vue